import { Trans, useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { getHajocaHealth } from "@/requests/hajoca/get-health";
import { useProductEvents } from "@/hooks/use-product-events";

export function HajocaHealth() {
  const { t } = useTranslation();
  const { data, isFetched } = useQuery(getHajocaHealth());
  const { capture } = useProductEvents({ component: "HajocaHealth" });

  // Only show warning if health check fails
  if (!isFetched) {
    return null; // Don't show anything while loading
  }

  if (data && data.status !== "ok") {
    capture({
      event: "show_health_banner",
      context: {},
    });
    return (
      <Alert variant="destructive" className="mb-4">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>{t("components.hajoca.health.orderSubmissionUnavailable")}</AlertTitle>
        <AlertDescription>
          <p>{t("components.hajoca.health.orderSubmissionIsCurrently")}</p>
          <p>
            <Trans
              i18nKey="components.hajoca.health.contactSupport"
              components={{
                email: (
                  <a
                    href="mailto:support@onsemble.com"
                    className="font-medium underline underline-offset-4"
                  />
                ),
              }}
            />
          </p>
        </AlertDescription>
      </Alert>
    );
  }

  return null; // Don't show anything if health is ok
}
